import { fork } from "redux-saga/effects";
import { productsWatcherSaga } from "./Product/saga";
import { brandsWatcherSaga } from "./Brands/saga";
import { instaMediaWatcherSaga } from "./InstaMedia/saga";
import { offersWatcherSaga } from "./Offer/saga";
import { modelsWatcherSaga } from "./Model/saga";
import { authWatcherSaga } from "./Auth/saga";
import { serviceOrdersWatcherSaga } from "./ServiceOrder/saga";
import { contactUsWatcherSaga } from "./ContactUs/saga";
import { currencyWatcherSaga } from "./SelectedCurrency/saga";
import { collectionsWatcherSaga } from "./Collections/saga";

export function* rootSaga() {
  yield fork(productsWatcherSaga);
  yield fork(brandsWatcherSaga);
  yield fork(instaMediaWatcherSaga);
  yield fork(offersWatcherSaga);
  yield fork(modelsWatcherSaga);
  yield fork(authWatcherSaga);
  yield fork(serviceOrdersWatcherSaga);
  yield fork(contactUsWatcherSaga);
  yield fork(currencyWatcherSaga);
  yield fork(collectionsWatcherSaga);
}
